export const addScriptCode = (scriptCode) => {
  return `
    <script>
        ${scriptCode}
    </script>
  `;
}

export function printHTML(htmlContent) {
  const updatedHTMLContent = htmlContent + addScriptCode(`
    window.onload = function() {
      window.print();
    }
  `);
  return updatedHTMLContent;
}
export function addTitle(htmlContent, title = 'Template') {
  const updatedHTMLContent = (`
  <html>
    <head>
      <title>${title}</title>
    </head>
    <body>
      ${htmlContent}
    </body>
  </html>`);
  return updatedHTMLContent;
}
export function addTitleAndStyle(htmlContent, style, title = 'Template') {
  const updatedHTMLContent = (`
  <html>
    <head>
      <title>${title}</title>
    </head>
    <body>
      ${htmlContent}
    </body>
    ${style}
  </html>`);
  return updatedHTMLContent;
}



export const openHTMLWindow = (htmlContent) => {
  const blob = new Blob([htmlContent], { type: "text/html;charset=utf-8" });

  const url = URL.createObjectURL(blob);

  window.open(url, "_blank");
}